import { render, staticRenderFns } from "./SharePopup.vue?vue&type=template&id=5b38f1ef"
import script from "./SharePopup.vue?vue&type=script&lang=js"
export * from "./SharePopup.vue?vue&type=script&lang=js"
import style0 from "./SharePopup.vue?vue&type=style&index=0&id=5b38f1ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports